import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

export function useVisitorTracking() {
  useEffect(() => {
    const logVisitor = async () => {
      try {
        // Check if visitor already has an ID
        let visitorID = localStorage.getItem("visitorID");
        let visitCount = localStorage.getItem("visitCount");

        if (!visitorID) {
          visitorID = uuidv4(); // Generate unique ID
          localStorage.setItem("visitorID", visitorID);
          visitCount = "1";
        } else {
          visitCount = String(parseInt(visitCount || "0") + 1);
        }

        localStorage.setItem("visitCount", visitCount); // Update visit count

        // Collect visitor info
        const visitorData = {
          visitorID: visitorID,
          visitCount: parseInt(visitCount),
          referrer: document.referrer || "Direct Visit",
          userAgent: navigator.userAgent
        };

        // Send data to Cloudflare Worker
        await fetch("https://jolly-bread-f6b7.dolfrin.workers.dev/api/analytics", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Visitor-Data": "Safe"
          },
          body: JSON.stringify(visitorData),
        });
      } catch (error) {
        // Silent fail - don't log errors to console
      }
    };

    // Log visit when component mounts
    logVisitor();
  }, []); // Empty dependency array means this runs once on mount
}